import { ViewerConstants } from "../../shared/model/viewer-constants";
import { IGeometry } from "../interfaces/i-geometry";
import { IMeasurementFeature } from "../interfaces/i-measurement-feature";

export const MeasurementFeature: (
  geometry: IGeometry,
  id: string,
  type: string,
  properties: any,
) => IMeasurementFeature = (geometry: IGeometry, id: string, type: string, properties: any) => ({
  geometry,
  id,
  type,
  properties,
  isPolygon: () => {
    return geometry.type === ViewerConstants.MEASUREMENT_TYPES[1];
  },
  isPoint: () => {
    return geometry.type === ViewerConstants.MEASUREMENT_TYPES[2];
  },
  isPolyline: () => {
    return geometry.type === ViewerConstants.MEASUREMENT_TYPES[0];
  },
  getType: () => {
    return geometry.type;
  },
  getArea: () => {
    return properties.measurement && properties.measurement.area ? properties.measurement.area.valuePretty : null;
  },
  getElevation: () => {
    return properties.measurement && properties.measurement.elevation
      ? properties.measurement.elevation.valuePretty
      : null;
  },
  getRelativeElevation: () => {
    return properties.measurement && properties.measurement.relativeElevation
      ? properties.measurement.relativeElevation.valuePretty
      : null;
  },
  getGroundElevation: () => {
    return properties.measurement && properties.measurement.ground ? properties.measurement.ground.valuePretty : null;
  },
  getLength: () => {
    return properties.measurement && properties.measurement.length ? properties.measurement.length.valuePretty : null;
  },
  getCircumference: () => {
    return properties.measurement && properties.measurement.circumference
      ? properties.measurement.circumference.valuePretty
      : null;
  },
  getRadius: () => {
    return properties.measurement && properties.measurement.radius ? properties.measurement.radius.valuePretty : null;
  },
  getHeight: () => {
    return properties.measurement && properties.measurement.height ? properties.measurement.height.valuePretty : null;
  },
  getSlope: () => {
    if (properties.measurement && properties.measurement.slopes && properties.measurement.slopes.length === 1) {
      return properties.measurement.slopes[0].valuePretty;
    }
    if (properties.measurement && properties.measurement.slope) {
      return properties.measurement.slope.valuePretty;
    }
    return null;
  },
  hasSlope: () => {
    const contains =
      (properties.measurement && properties.measurement.slopes && properties.measurement.slopes.length === 1) ||
      (properties.measurement && properties.measurement.slope);
    return contains;
  },
  isPlanar: () => {
    if (properties.measurement && properties.measurement.slopes && properties.measurement.slopes.length === 1) {
      return properties.measurement.slopes[0].planar;
    }
    if (properties.measurement && properties.measurement.slope) {
      return properties.measurement.slope.planar;
    }
    return false;
  },

  getSlopes: () => {
    return properties.measurement && properties.measurement.slopes ? properties.measurement.slopes : null;
  },

  getLocation: () => {
    return properties.measurement && properties.measurement.location ? properties.measurement.location.value : null;
  },
  getLengthName: () => {
    if (geometry.type === ViewerConstants.MEASUREMENT_TYPES[0]) {
      return "Length";
    }
    if (geometry.type === ViewerConstants.MEASUREMENT_TYPES[1]) {
      return "Perimeter";
    }
    return null;
  },
  hasMeasurement: () => {
    return properties && !!properties.measurement;
  },
  getMeasurement: () => {
    return properties.measurement;
  },
  getElevationUnit: () => {
    return properties.measurement && properties.measurement.elevation ? properties.measurement.elevation.unit : null;
  },
  getRelativeElevationUnit: () => {
    return properties.measurement && properties.measurement.relativeElevation
      ? properties.measurement.relativeElevation.unit
      : null;
  },
  getGroundElevationUnit: () => {
    return properties.measurement && properties.measurement.ground ? properties.measurement.ground.unit : null;
  },
  getAreaUnit: () => {
    return properties.measurement && properties.measurement.area ? properties.measurement.area.unit : null;
  },
  getLengthUnit: () => {
    return properties.measurement && properties.measurement.length ? properties.measurement.length.unit : null;
  },
  getCircumferenceUnit: () => {
    return properties.measurement && properties.measurement.circumference
      ? properties.measurement.circumference.unit
      : null;
  },
  getRadiusUnit: () => {
    return properties.measurement && properties.measurement.radius ? properties.measurement.radius.unit : null;
  },
  getHeightUnit: () => {
    return properties.measurement && properties.measurement.height ? properties.measurement.height.unit : null;
  },
  getSlopeUnit: () => {
    if (properties.measurement && properties.measurement.slopes && properties.measurement.slopes.length === 1) {
      return properties.measurement.slopes[0].unit;
    }
    if (properties.measurement && properties.measurement.slope) {
      return properties.measurement.slope.unit;
    }
    return null;
  },
  getInfo: () => {
    return properties.measurement && properties.measurement.info ? properties.measurement.info : null;
  },
});
